import * as React from "react";
function SvgIcLoginNo2(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={14} height={14} rx={7} fill="#686868" /><path fillRule="evenodd" clipRule="evenodd" d="M8 11a1 1 0 11-2 0 1 1 0 012 0zM7 2a.931.931 0 00-.929.997l.393 5.504a.537.537 0 001.072 0l.393-5.504A.931.931 0 007 2z" fill="#fff" /></svg>;
}
export default SvgIcLoginNo2;